import { Remote } from "comlink";
import { GetState, SetState } from "zustand";
import { BetStore } from "..";
import isServer from "../../../libs/is-server";
import { Bet, BetRow } from "../../../types/bet";
import { IDBBetHandler } from "../../../workers/idb-bet-storer";
import { IDBBetSyncHandler } from "../../../workers/idb-bet-sync-handler";
import useAppStore, { ReductionRequirementView } from "../../app-store";
import uploadBet from "../upload-bet";

export const addBaseHorseReduction = async (
  shouldUpdateReductionView: boolean,
  set: SetState<BetStore>,
  get: GetState<BetStore>,
  idbBetWorkerApi?: Remote<IDBBetHandler>,
  idbBetSyncWorkerApi?: Remote<IDBBetSyncHandler>
): Promise<void> => {
  const { bet } = get();

  const { currentBetId } = useAppStore.getState();

  if (!currentBetId || !bet) {
    return;
  }

  const { reductionRequirement } = bet;

  const addBaseHorseReductionToRow = (row: BetRow): BetRow => {
    return {
      ...row,
      baseHorseReductions: [
        ...(row.baseHorseReductions || []),
        row.order.map(() => false),
      ],
    };
  };

  const newBet: Bet = {
    ...bet,
    reductionRequirement: {
      ...reductionRequirement,
      baseHorseReductions: [
        ...(reductionRequirement.baseHorseReductions || []),
        {
          minWinners: null,
          maxWinners: null,
        },
      ],
    },
    rows: bet.rows.map(addBaseHorseReductionToRow),
  };

  set({
    bet: newBet,
    uploading: true,
  });

  if (shouldUpdateReductionView) {
    useAppStore
      .getState()
      .setReductionRequirementView(
        ReductionRequirementView.BASE_HORSE,
        (newBet.reductionRequirement.baseHorseReductions?.length || 1) - 1
      );
  }

  if (!isServer) {
    uploadBet(
      currentBetId,
      newBet,
      () => set({ uploading: false }),
      idbBetSyncWorkerApi
    );

    if (idbBetWorkerApi) idbBetWorkerApi.storeBet(currentBetId, newBet);
  }
};
